// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__A7ATZ","container":"style_container__v3gc-","frame":"style_frame__kHN3P","content":"style_content__ANxGJ"};